import axios from 'axios';
import '/src/services/axios-interceptor';
import authHeader from '/src/services/auth-header';
const API_URL_Analy = process.env.VUE_APP_BASE_URL_API + '/analytics/';
const API_URL_Affil = process.env.VUE_APP_BASE_URL_API + '/affiliate/';
const API_URL_Locat = process.env.VUE_APP_BASE_URL_API + '/location/';
const API_URL_MedProv = process.env.VUE_APP_BASE_URL_API + '/medicalProvider/';

class AnalyticsService {
   // analytics
   findStatus( code ) {
      return axios.get(API_URL_Analy + 'find_status',
         {  params: { code: code },
            headers: authHeader() 
         }
      );
   }
   getAnalyticalType( code ) {
      return axios.get(API_URL_Analy + 'getanalyticaltype',
         {  params: { code: code },
            headers: authHeader()
         }
      );
   }
   getUpdateErrors( code ) {
      return axios.get(API_URL_Analy + 'getupdateerrors',
         {  params: { code: code },
            headers: authHeader()
         }
      );
   }
   updateAffiliates() {
      return axios.post(API_URL_Analy + 'updateaffiliates', {},
         { headers: authHeader() }
      );
   }
   // affiliate
   affiliateExists( id ) {
      return axios.get(API_URL_Affil + 'affiliateexists',
         {  params: { id: id },
            headers: authHeader()
         }
      );
   }
   getAffiliateBasicData( id ) {
      return axios.get(API_URL_Affil + 'getaffiliatebasicdata',
         {  params: { id: id },
            headers: authHeader()
         }
      );
   }
   findAffiliateAllData( itemsByPage, start, searchText, searchOption ) {
      return axios.post(API_URL_Affil + 'findaffiliatealldata', {
         itemsByPage: itemsByPage,
         start: start,
         searchText: searchText,
         searchOption: searchOption
         },
         { headers: authHeader() }
      );
   }
   // location
   getStates( countryId ) {
      return axios.get(API_URL_Locat + 'get_states',
         {  params: { countryId: countryId },
            headers: authHeader()
         }
      );
   }
   // medicalProvider
   countMedicalProviderByCode( code, id ) {
      return axios.get(API_URL_MedProv + 'count_medical_provider_by_code',
         {  params: { 
               code: code,
               id: id
            },
            headers: authHeader()
         }
      );
   }
   findMedicalProvider() {
      return axios.get(API_URL_MedProv + 'find_medical_provider',
         { headers: authHeader() }
      );
   }
   findProvincesStates() {
      return axios.get(API_URL_MedProv + 'find_provinces_states',
         { headers: authHeader() }
      );
   }
   getMedicalProvider( id ) {
      return axios.get(API_URL_MedProv + 'get_medical_provider',
         {  params: { id: id },
            headers: authHeader()
         }
      );
   }
   medicalProviderExists( id ) {
      return axios.get(API_URL_MedProv + 'medical_provider_exists',
         {  params: { id: id },
            headers: authHeader()
         }
      );
   }
   updateMedicalProvider( upMedicalProvider ) {
      return axios.post(API_URL_MedProv + 'update_medical_provider', upMedicalProvider,
         { headers: authHeader() }
      );
   }
   findMedicalProviderAllData( itemsByPage, start, searchText, searchOption ) {
      return axios.post(API_URL_MedProv + 'find_medical_provider_all_data', {
         itemsByPage: itemsByPage,
         start: start,
         searchText: searchText,
         searchOption: searchOption
         },
         { headers: authHeader() }
      );
   }
}

export default new AnalyticsService();